// This file is auto-generated by @hey-api/openapi-ts

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteByIdData, DeleteByIdErrors, DeleteByIdResponses, DeleteCartItemByIdData, DeleteCartItemByIdErrors, DeleteCartItemByIdResponses, DeleteClearCartData, DeleteClearCartErrors, DeleteClearCartResponses, GetCartData, GetCartResponses, GetOrderData, GetOrderResponses, PostAddToCartData, PostAddToCartErrors, PostAddToCartResponses, PostApplyDiscountOrGiftCardCodeData, PostApplyDiscountOrGiftCardCodeErrors, PostApplyDiscountOrGiftCardCodeResponses, PostInitPaymentData, PostInitPaymentErrors, PostInitPaymentResponses, PostProductsSearchData, PostProductsSearchErrors, PostProductsSearchResponses, PostRemoveDiscountOrGiftCardCodeData, PostRemoveDiscountOrGiftCardCodeErrors, PostRemoveDiscountOrGiftCardCodeResponses, PostSetPaymentMethodData, PostSetPaymentMethodErrors, PostSetPaymentMethodResponses, PostSetShippingMethodData, PostSetShippingMethodErrors, PostSetShippingMethodResponses, PostSetupBuyNowOrderData, PostSetupBuyNowOrderErrors, PostSetupBuyNowOrderResponses, PostUpdateCustomerInformationData, PostUpdateCustomerInformationErrors, PostUpdateCustomerInformationResponses, PostUpdatePreferencesData, PostUpdatePreferencesResponses, PostUploadData, PostUploadErrors, PostUploadResponses, PutUpdateCartItemData, PutUpdateCartItemErrors, PutUpdateCartItemResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export class CheckoutService {
    public static postApplyDiscountOrGiftCardCode<ThrowOnError extends boolean = false>(options: Options<PostApplyDiscountOrGiftCardCodeData, ThrowOnError>) {
        return (options.client ?? client).post<PostApplyDiscountOrGiftCardCodeResponses, PostApplyDiscountOrGiftCardCodeErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/apply-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postUpdateCustomerInformation<ThrowOnError extends boolean = false>(options: Options<PostUpdateCustomerInformationData, ThrowOnError>) {
        return (options.client ?? client).post<PostUpdateCustomerInformationResponses, PostUpdateCustomerInformationErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/customer-info',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postInitPayment<ThrowOnError extends boolean = false>(options: Options<PostInitPaymentData, ThrowOnError>) {
        return (options.client ?? client).post<PostInitPaymentResponses, PostInitPaymentErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/init-payment',
            ...options
        });
    }
    
    public static postRemoveDiscountOrGiftCardCode<ThrowOnError extends boolean = false>(options: Options<PostRemoveDiscountOrGiftCardCodeData, ThrowOnError>) {
        return (options.client ?? client).post<PostRemoveDiscountOrGiftCardCodeResponses, PostRemoveDiscountOrGiftCardCodeErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/remove-code',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSetPaymentMethod<ThrowOnError extends boolean = false>(options: Options<PostSetPaymentMethodData, ThrowOnError>) {
        return (options.client ?? client).post<PostSetPaymentMethodResponses, PostSetPaymentMethodErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/set-payment-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSetShippingMethod<ThrowOnError extends boolean = false>(options: Options<PostSetShippingMethodData, ThrowOnError>) {
        return (options.client ?? client).post<PostSetShippingMethodResponses, PostSetShippingMethodErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/set-shipping-method',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postSetupBuyNowOrder<ThrowOnError extends boolean = false>(options: Options<PostSetupBuyNowOrderData, ThrowOnError>) {
        return (options.client ?? client).post<PostSetupBuyNowOrderResponses, PostSetupBuyNowOrderErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/{storeId}/setup-buy-now-order',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static getOrder<ThrowOnError extends boolean = false>(options?: Options<GetOrderData, ThrowOnError>) {
        return (options?.client ?? client).get<GetOrderResponses, unknown, ThrowOnError>({
            url: '/umbraco/site/api/v1/checkout/order',
            ...options
        });
    }
}

export class FormsService {
    public static postUpload<ThrowOnError extends boolean = false>(options?: Options<PostUploadData, ThrowOnError>) {
        return (options?.client ?? client).post<PostUploadResponses, PostUploadErrors, ThrowOnError>({
            ...formDataBodySerializer,
            url: '/umbraco/site/api/v1/forms/upload',
            ...options,
            headers: {
                'Content-Type': null,
                ...options?.headers
            }
        });
    }
    
    public static deleteById<ThrowOnError extends boolean = false>(options: Options<DeleteByIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteByIdResponses, DeleteByIdErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/forms/upload/{id}',
            ...options
        });
    }
}

export class ProductsService {
    public static postProductsSearch<ThrowOnError extends boolean = false>(options?: Options<PostProductsSearchData, ThrowOnError>) {
        return (options?.client ?? client).post<PostProductsSearchResponses, PostProductsSearchErrors, ThrowOnError>({
            url: '/api/v1/products/Search',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
}

export class SessionService {
    public static deleteClearCart<ThrowOnError extends boolean = false>(options?: Options<DeleteClearCartData, ThrowOnError>) {
        return (options?.client ?? client).delete<DeleteClearCartResponses, DeleteClearCartErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/cart',
            ...options
        });
    }
    
    public static getCart<ThrowOnError extends boolean = false>(options?: Options<GetCartData, ThrowOnError>) {
        return (options?.client ?? client).get<GetCartResponses, unknown, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/cart',
            ...options
        });
    }
    
    public static postAddToCart<ThrowOnError extends boolean = false>(options?: Options<PostAddToCartData, ThrowOnError>) {
        return (options?.client ?? client).post<PostAddToCartResponses, PostAddToCartErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/cart',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
    
    public static deleteCartItemById<ThrowOnError extends boolean = false>(options: Options<DeleteCartItemByIdData, ThrowOnError>) {
        return (options.client ?? client).delete<DeleteCartItemByIdResponses, DeleteCartItemByIdErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/cart/{id}',
            ...options
        });
    }
    
    public static putUpdateCartItem<ThrowOnError extends boolean = false>(options: Options<PutUpdateCartItemData, ThrowOnError>) {
        return (options.client ?? client).put<PutUpdateCartItemResponses, PutUpdateCartItemErrors, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/cart/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static postUpdatePreferences<ThrowOnError extends boolean = false>(options?: Options<PostUpdatePreferencesData, ThrowOnError>) {
        return (options?.client ?? client).post<PostUpdatePreferencesResponses, unknown, ThrowOnError>({
            url: '/umbraco/site/api/v1/session/preferences',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers
            }
        });
    }
}
